import api from '../api';
export const showModal = ({ commit }, { modaldata, type }) => {
  commit('showModal', { modaldata, type });
  commit('toggleModal');
};

export const setActiveBlock = ({ commit }, { blockCode }) => {
  commit('setNotActiveChooseStock', 0);
  Acme.getHqData(
    {
      code: [blockCode],
      type: ['zqmc', 'new'],
      period: 'now',
      mode: 'after'
    },
    data => {
      const activeBlock = {
        blockCode: blockCode,
        blockName: data[blockCode]['zqmc']
      };
      commit('setActiveBlock', activeBlock);
    },
    error => {
      console.log(error);
    }
  );
};
export const setNotActiveChooseStock = ({ commit }, active) => {
  commit('setNotActiveChooseStock', active);
};
const getZdf = ({ commit }, stockCodes) => {
  Acme.getHqData(
    {
      code: stockCodes,
      type: ['zqmc', 'new', 'zhangdiefu'],
      period: 'now',
      mode: 'after'
    },
    data => {
      const stockArr = [];
      for (let stockcode of Object.keys(data)) {
        stockArr.push({
          stockCode: stockcode + '',
          stockName: data[stockcode]['zqmc'],
          zhangfu: data[stockcode]['zhangdiefu']
        });
      }

      commit('setBlockStocks', stockArr);
    },
    error => {
      console.log('当前板块没有成分股', error);
      commit('setBlockStocks', []);
    }
  );
};

export const setActiveChooseBlock = ({ commit, state }, { activeChooseBlock }) => {
  commit('setActiveChooseBlock', activeChooseBlock);
  // console.log('我走了2次', activeChooseBlock);
  api.hotSpotAnalysis.getPlateStockCodeList(activeChooseBlock['blockCode']).then(res => {
    clearInterval(this.zdfInterval);
    // console.log(activeChooseBlock['blockCode'], state.activeBlock.blockCode, '这个是请求板块下面的个股');
    // console.log(state.activeBlock.blockCode == activeChooseBlock['blockCode'], '111');
    if (state.activeChooseBlock.blockCode == activeChooseBlock['blockCode']) {
      if (res.data.errorcode === 0 && res.data.result && res.data.result.length > 0) {
        const stockCodes = res.data.result.join(',');

        getZdf({ commit }, stockCodes);
        this.zdfInterval = setInterval(() => {
          getZdf({ commit }, stockCodes);
        }, 60000);
      } else {
        commit('setBlockStocks', []);
      }
    }
  });
};
export const setBlockStocks = ({ commit }, { blockStocks }) => {
  commit('setBlockStocks', blockStocks);
};
export const setActiveChooseStock = ({ commit }, { activeChooseStock }) => {
  commit('setActiveChooseStock', activeChooseStock);
};



// WEBPACK FOOTER //
// ./src/store/actions.js